import store from '@/store/store'
export default {
  numberValidate:function (params){
    let reg=new RegExp('^[0-9]*$');
    return reg.test(params);
  },
    breadcrumbHighlight:function(eq){
        let breadcrumbList = document.getElementsByClassName('ivu-breadcrumb-item-link')
        for(let i=0;i<breadcrumbList.length;i++){
            breadcrumbList[i].style.color=''
        }
        breadcrumbList[eq].style.color='#2d8cf0'
    },
    handleSubmit(_this,i) {
        let tempRouter = _this.$t('newCommonRes.router')
        this.breadcrumbHighlight(i)
        _this.$router.push('/patient/'+ tempRouter[i]);
        let currentStep = _this.$store.state.step;
        if(!currentStep || currentStep>= i-1){
            store.commit('createCaseStep',i)
            // store._mutations.createCaseStep(i)
            // _this.createCaseStep(i)
        }
    },
    handleReset(_this,i) {
        let tempRouter = _this.$t('newCommonRes.router')
        this.breadcrumbHighlight(i)
        _this.$router.push('/patient/'+tempRouter[i])
    },
    //退出
    handleCancel(_this) {
        let update = sessionStorage.getItem('updateCaseId');
        if (update) {
            _this.$router.push('/patientMessage');
        } else {
            _this.$router.push('/patientList');
        }
    },
}



// WEBPACK FOOTER //
// ./src/assets/js/common.js